import { dataVideoHistorySolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconVideoHistorySolid = /*#__PURE__*/createIcon(dataVideoHistorySolid)
export default IconVideoHistorySolid
